import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { adminCategoryAPI } from '../../../admin/Handlers/categoryAPI';
import styles from './CategoriesFeatured.module.css';

const CategoriesFeatured = () => {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await adminCategoryAPI.list();
        const data = res?.data || res || [];
        if (mounted) {
          setCats(data);
          setLoading(false);
        }
      } catch (e) {
        console.error('Erro fetch categories', e);
        setLoading(false);
      }
    })();
    return () => { mounted = false };
  }, []);

  if (!loading && cats.length === 0) return null;

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={styles.title}
        >
          Explore as Categorias
        </motion.h2>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className={styles.subtitle}
        >
          Equipamentos de alto desempenho para missões reais.
        </motion.p>
      </header>
      
      <div className={styles.wrapper}>
        <AnimatePresence>
          {loading 
            ? [...Array(5)].map((_, i) => <div key={i} className={styles.skeleton} />)
            : cats.map((cat, index) => (
                <motion.a
                  key={cat.id}
                  href={`/products?category=${cat.id}`}
                  className={styles.categoryBadge}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{ scale: 1.05, translateY: -5 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ duration: 0.2, delay: index * 0.05 }}
                >
                  <span className={styles.name}>{cat.name}</span>
                  <div className={styles.iconWrapper}>
                    <svg className={styles.arrow} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </motion.a>
              ))
          }
        </AnimatePresence>
      </div>
    </section>
  );
};

export default CategoriesFeatured;